import React from 'react'

/* doc
---
title: LevelItem
name: LevelItem
category: React - Bulma
parent: Level
---

A `LevelItem` component based on Bulma `.level-item`. This should be used as a
child of `Level`.

See [Bulma Documentation](http://bulma.io/documentation/components/level/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.


```html_example
  <Level>
    <LevelItem>
      ...
    </LevelItem>
    <LevelItem>
      ...
    </LevelItem>
  </Level>
```
*/
function LevelItem(props) {
  const {
    children, className, canWrapContent, isNarrow, ...rest
  } = props

  const classes = [
    'level-item',
    isNarrow ? 'is-narrow' : '',
    className || '',
    canWrapContent ? 'can-wrap-content' : '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}

export default LevelItem
